(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.cancellations.canceledMatches
   * @description
   *
   */
  angular
    .module('neo.home.cancellations.canceledMatches', [
      'ui.router',
      'neo.home.cancellations.canceledMatches.postponeCanceledMatches'

    ]);
}());
